/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_StartInputs */

const en_filter_has_start = /** @type {(inputs: Filter_Has_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a start date`)
};

const de_filter_has_start = /** @type {(inputs: Filter_Has_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/**
* | output |
* | --- |
* | "a start date" |
*
* @param {Filter_Has_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_start = /** @type {((inputs?: Filter_Has_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_start(inputs)
	return en_filter_has_start(inputs)
});